<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton
      :row="30"
      :loading="loading"
      style="margin-top: 1em;"
    >
      <div class="pageBody" v-html="body" />
    </van-skeleton>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Skeleton } from 'vant'
import { getUrlKey, getUserBase, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      showbody: undefined,
      body: undefined,
      title: '',
      backurl: '/store/index',
      loading: true
    }
  },
  created() {
    setTimeout(() => {
      getUserBase(data => {
        this.titleTop = GetSysTitle()
      })
    }, 1)
    var userId = getUrlKey('uid')
    this.showbody = this.$route.params.code
    request({
      url: '/data/getPage',
      method: 'post',
      data: {
        code: this.showbody,
        uidQrCode: userId
      }
    }).then(response => {
      this.loading = false
      if (response.success) {
        this.body = response.data.body
        this.title = response.data.title
      } else {
        this.body = '无内容'
        this.title = '空页面'
      }
    })
  },
  methods: {
    getUrlKey,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle
  }
}
</script>

<style scoped>
.pageBody{
  padding: 0 1em;

}
</style>

<style>
.pageBody img{
  max-width:100%;
}
</style>
